<template>
  <Header/>
  <div id="body">
    <router-view/>
  </div>
  <div id="back-top-btn" class="base btn-blue caps b-to-top">
    <button class="btn-mr" @click="backToTopClickHandler">&#8593;</button>
  </div>
  <Footer/>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  mounted() {
    this.$nextTick(window.onscroll = function() {
        const backToTopButton = document.getElementById("back-top-btn");
        if ((window.scrollY == 0 && window.scrollX == 0) || ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 50)) {
            backToTopButton.style.visibility = 'hidden';
        } else {
            backToTopButton.style.visibility = 'visible';
        }
    });
  },
  methods: {
      backToTopClickHandler() {
          scrollTo(0,0);
      }
  }
}
</script>